/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useMemo, useRef } from "react";
import { useAnimations, MeshWobbleMaterial, Instance, Instances, useTexture } from "@react-three/drei";
import { useDracoGLTF } from "../../../../utils/useDracoGLTF";
import {
  DoubleSide,
  Euler,
  MathUtils,
  MeshBasicMaterial,
  MeshStandardMaterial,
  Quaternion,
  RepeatWrapping,
  Vector3,
} from "three";

import { useFrame } from "@react-three/fiber";

import waterVertexShader2 from "../../shader/waterVert_2.glsl";
import waterFragShader2 from "../../shader/waterFrag_2.glsl";

import { Color } from "three";
import { ShaderMaterial } from "three";

export default function WaterStream({ ...props }) {
  const group = useRef();
  const { nodes, materials, animations } = useDracoGLTF("./models/heat/Water.glb");
  const { actions } = useAnimations(animations, group);
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh name="Wata" geometry={nodes.Wata.geometry} scale={1.35}>
          <meshPhysicalMaterial
            transmission={0.9}
            thickness={0.6}
            roughness={0.08}
            metalness={0.0}
            // opacity={0.2}
            color="#e6efff"
            ior={1.2}
            depthWrite={false}
          />
        </mesh>
      </group>
    </group>
  );
}

const streamcount = 84;
// const streamcount = 3;
const streamsPerRow = 6;

const z = 1.4;
const y = 2.75;
const streamRowWidth = z / streamsPerRow;
const streamColumnWidth = y / (streamcount / streamsPerRow);

const randomVector = (r) => [0, y / 2 - Math.random() * y, z / 2 - Math.random() * z];

const gridPosition = (i) => {
  var xPos = 0;
  var rowPos = i % streamsPerRow;
  var zPos = -(z / 2) + rowPos * streamRowWidth;
  var column = Math.floor(i / streamsPerRow);
  var yPos = y / 2 - column * streamRowWidth;
  return [xPos, yPos, zPos];
};

// const randomData = Array.from({ length: streamcount }, (r = 10) => ({
//   random: Math.random(),
//   position: randomVector(r),
// }));

export const GridWaterStreams = ({ ...props }) => {
  const gridData = useMemo(() => {
    const randomData = [];

    for (let index = 0; index < streamcount; index++) {
      randomData.push({
        random: Math.random(),
        position: gridPosition(index),
      });
    }

    return randomData;
  }, []);

  return <WaterStreams {...props} positionData={gridData} />;
};

const radialStreamsCount = 30;
const radius = 1.5;

const circularPositionRotation = (index) => {
  var rot = (360 / radialStreamsCount) * index;

  var rotQuat = new Quaternion();
  rotQuat.setFromEuler(new Euler(0, MathUtils.degToRad(rot), 0));

  var dir = new Vector3(radius, 0, 0);
  dir.applyQuaternion(rotQuat);

  var pos = dir;

  rotQuat.setFromAxisAngle(new Vector3(0, 1, 0), MathUtils.degToRad(rot));
  var eulers = new Euler();
  eulers.setFromQuaternion(rotQuat);

  return {
    position: pos,
    rotation: [eulers.x, eulers.y, eulers.z],
  };
};

export const CircularWaterStreams = ({ ...props }) => {
  const gridData = useMemo(() => {
    const randomData = [];

    for (let index = 0; index < radialStreamsCount; index++) {
      randomData.push({
        random: Math.random(),
        position: circularPositionRotation(index).position,
        rotation: circularPositionRotation(index).rotation,
      });
    }

    return randomData;
  }, []);

  return <WaterStreams {...props} positionData={gridData} />;
};

export const WaterStreams = ({ positionData, ...props }) => {
  const { nodes, materials, animations } = useDracoGLTF("./models/heat/Water.glb");

  useFrame(({ clock, ...state }) => {
    waterMaterial.uniforms.uTime.value = clock.elapsedTime;
  });

  const waterMaterial = useMemo(() => {
    var mat3 = new ShaderMaterial({
      fragmentShader: waterFragShader2,
      vertexShader: waterVertexShader2,
      vertexColors: true,
      transparent: true,
      depthWrite: false,
      side: DoubleSide,
      uniforms: {
        uTime: {
          value: 0,
        },
        uSpeed: {
          value: 1.85,
        },
        uNoiseScale: {
          value: 20,
        },
      },
    });

    return mat3;
  }, []);

  return (
    <group {...props}>
      <Instances range={streamcount} material={waterMaterial} geometry={nodes.Wata.geometry} scale={0.04}>
        {positionData.map((props, i) => (
          <Water key={i} {...props} />
        ))}
      </Instances>
    </group>
  );
};

const Water = ({ random, ...props }) => {
  const ref = useRef();

  // console.log(ref.current);
  useEffect(() => {
    if (ref.current) {
      ref.current.color = new Color(Math.random(), Math.random(), Math.random());
      // ref.current.color = new Color(1, 0, 0);
      // console.log(ref.current);
    }
  }, [ref.current]);

  useFrame((state) => {
    const t = state.clock.getElapsedTime() + random * 10000;
    // ref.current.rotation.set(
    //   Math.cos(t * 100 / 4) / 120,
    //   Math.sin(t * 100 / 4) / 120,
    //   Math.cos(t * 100 / 1.5) / 120
    // );

    // ref.current.material.displacementScale = Math.cos(t * 100 / 4) / 120
  });
  return (
    <group {...props} scale={[1, 1, 1]}>
      <Instance ref={ref}></Instance>
    </group>
  );
};
